import { IconName } from '../icons';

export interface FooterNavigationItem {
  name: string;
  href: string;
  badge?: string;
  icon?: IconName;
}

interface FooterNavigationConfig {
  items: {
    services: FooterNavigationItem[];
    support: FooterNavigationItem[];
    about: FooterNavigationItem[];
    legal: FooterNavigationItem[];
    social: FooterNavigationItem[];
  };
}

export const FooterNavigation: FooterNavigationConfig = {
  items: {
    services: [
      { name: 'Car Wraps', href: '/car-wraps-edmonton' },
      { name: 'Truck Wraps', href: '/truck-wraps' },
      { name: 'Vinyl Wraps', href: '/vinyl-wrap-edmonton' },
      { name: 'Fleet Wraps', href: '/fleet-wraps' },
      { name: 'Signs', href: '/signs-edmonton' },
      { name: 'Architectural Wraps', href: '/architectural-wraps' },
      { name: 'Wall Murals', href: '/wall-murals' },
      { name: 'Large Format Printing', href: '/large-format-printing' },
      { name: 'Paint Protection', href: '/paint-protection' }
    ],
    support: [
      { name: 'Cargo Vans', href: '/fleet-wraps/cargo-vans' },
      { name: 'Box Trucks', href: '/fleet-wraps/box-trucks' },
      { name: 'Pickup Trucks', href: '/fleet-wraps/pickup-trucks' },
      { name: 'Food Trucks', href: '/fleet-wraps/food-trucks' },
      { name: 'HVAC & Plumbing', href: '/fleet-wraps/hvac-plumbing' },
      { name: 'Construction', href: '/fleet-wraps/construction' },
      { name: 'All Fleet Categories →', href: '/fleet-wraps' }
    ],
    about: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'Request a Quote', href: '/quote' },
      { name: 'About Us', href: '/about' },
      { name: 'FAQ', href: '/faq' },
      { name: 'Pricing', href: '/pricing' },
      { name: 'Boat Wrap Pricing', href: '/boat-wrap-pricing' },
      { name: 'Colours Showcase', href: '/colours' },
      { name: 'Gallery', href: '/gallery' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Warranty', href: '/warranty' },
      { name: 'Warranty Claim', href: '/warranty-claim' },
      { name: 'Waiver', href: '/waiver' },
      { name: 'Legal', href: '/legal' },
      { name: 'Terms & Refund Policy', href: '/terms' }
    ],
    social: [
      // The shop's live accounts, confirmed by Peter 2026-09-11. No LinkedIn, no X.
      { name: 'Facebook', href: 'https://www.facebook.com/choicewraps', icon: 'facebook' },
      { name: 'Instagram', href: 'https://instagram.com/choicewraps', icon: 'instagram' },
      { name: 'YouTube', href: 'https://www.youtube.com/@choicewraps', icon: 'youtube' }
    ]
  }
};
